var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ServiceChart'),_c('br'),_c('CustomerChart'),_c('br'),_c('RepurchaseChart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }